// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:38Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Rozhraní pro práci s geodaty. Generated from cz.marbes.api.objekt.DescriptionService.
 */
export default class DescriptionApi {
    /**
     * Vrátí popis GeoJSON objektu.
     *
     * @param geo 
     * @return popis GeoJSON objektu
     */
    static describeGeometry(geo : GeoJsonObject) : Promise<GeoDescription> {
        const uri = serverContextPath + `/api/obj/description/describeGeo`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, geo, headers));
    }

}